module.exports = __webpack_public_path__ + "assets/loop-edit-list.8251d96a.svg";